module.exports = __webpack_public_path__ + "static/media/stop.df4f5abd.svg";